import CandidateProfilePictureComponent from '@/public/shared/components/candidate-profile-picture-component/candidate-profile-picture-component.vue';
import { ICandidate } from '@/shared/api-client/models/candidate';
import GenderIconComponent from '@/shared/components/gender-icon-component/gender-icon-component.vue';
import { ArgumentValidator } from '@/shared/helpers/argument-validator';
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

export type ICandidateOrderingDirection = 'Forward' | 'Backward';

export interface ICandidateOrderingNewPositionEvent {

    candidate: ICandidate;

    direction: ICandidateOrderingDirection;
}

@Component({
    components: {
        GenderIconComponent,
        CandidateProfilePictureComponent
    }
})
export default class CandidateRankingComponent extends Vue {
    @Prop({default: []}) public selectedCandidates!: ICandidate[];
    @Prop({default: false}) public showGenders!: boolean;
    @Prop({default: true}) public showProfilePictures!: boolean;
    @Prop() public translations!: { [key: string]: string; };

    constructor() {
        super();
    }

    @Emit()
    public reOrdered(candidate: ICandidate, direction: ICandidateOrderingDirection): ICandidateOrderingNewPositionEvent {

        ArgumentValidator.notNullOrEmpty(candidate, 'candidate');

        return {
            candidate,
            direction
        };
    }
}
